import { render } from "./SpinnerComponent.vue?vue&type=template&id=73f08838"
const script = {}

import "./SpinnerComponent.vue?vue&type=style&index=0&id=73f08838&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__